/**
 * 功能: 显示报告里附件的数据 展示作用
 */
<template lang="pug">
  div.show-attachment(:id="'p'+attachmentInfo._id")
    // 类型：0=图片，1=政策；2=Size；3=专家说
    div.attachment-info(v-if="attachmentInfo._class === 0 " )
      div(style=" text-align: center" )
        p.attachment-title {{ attachmentInfo.explain }} {{ attachmentInfo.title }}
        //- img(:src ="GLOBAL.OSS+attachmentInfo.hiImageUrl" width="80%")
        img(ref="illImg" width="80%")
        p.source(style="width:100%;text-align: right;font-style:italic" v-if="attachmentInfo.source") 来源：{{ attachmentInfo.source }}
        i.el-icon-info.memo.operation(@click="showMemoDialog" v-if="attachmentInfo.internalMemo")
    div.attachment-info(v-if="attachmentInfo._class === 1 ")
      p.attachment-title(style="text-align: center;") {{ attachmentInfo.explain }} {{ attachmentInfo.title }}
      div.tablelook(v-html="attachmentInfo.html")
      p.source(style="width:100%;text-align: right;font-style:italic" v-if="attachmentInfo.source") 来源：{{ attachmentInfo.source }}
      i.el-icon-info.memo.operation(@click="showMemoDialog" v-if="attachmentInfo.internalMemo")
    div.attachment-info(v-if="attachmentInfo._class === 2 ")
      p.attachment-title(style="text-align: center") {{ attachmentInfo.explain }} {{ attachmentInfo.newTitle }}
      div(style='width:100%;height:100%')
        drawSziePro(:dialogData="attachmentInfo")
      p.source(style="width:100%;text-align: right;font-style:italic" v-if="attachmentInfo.source") 来源：{{ attachmentInfo.source }}
      i.el-icon-info.memo.operation(@click="showMemoDialog" v-if="attachmentInfo.internalMemo")
    div.attachment-info(v-if="attachmentInfo._class === 3 ")
      p.attachment-title() {{ attachmentInfo.expertName }}说: {{ attachmentInfo.content }}
      i.el-icon-info.memo.operation(@click="showMemoDialog" v-if="attachmentInfo.internalMemo")
    memoDialog(ref="memoDialog" :isDisabled="true" :relativeId="attachmentInfo.subObject")
</template>

<script>
import drawSziePro from '@/views/size/components/drawsizePro'
import memoDialog from '@/components/dialog'
import api from '@/apis/commuCore'
export default {
  name: 'showAttchment',
  components: { drawSziePro, memoDialog },
  props: {
    attachmentInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    showMemoDialog () {
      this.$refs.memoDialog.show()
    }
  },
  created () {
    const self = this
    if (this.attachmentInfo._class === 0) {
      api.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + this.attachmentInfo.hiImageUrl).then(res => {
        self.$refs.illImg.src = window.URL.createObjectURL(res)
      })
    }
  }
}
</script>

<style lang="scss">
.attachment-info {
  position: relative;
  border-radius: 4px;
  margin-bottom: 5px;

  &:hover {

    .operation  {
      display: block;
      font-size: 18px;
      padding: 4px;

      &:hover {
        background-color: #ccc;
        padding: 4px;
        font-size: 18px;
        display: block;
      }
    }
  }

  .operation {
    display: none;
    position: absolute;
    font-size: 16px;
    top: 0;
    right: 20px;
  }
}
.memo{
  position: absolute;
  right: 0;
  top: 0;
}
.tablelook{
  font-size: 14px !important;
}
.source{
  font-size: smaller;
}
.attachment-title{
  font-size: 14px;
  font-weight:bold
}
</style>
